export const clientDetailsModel = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
};
